/**
 * Created by mnaughton on 10/20/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
import Field from "core/models/Field";
import UrlBuilder from "@HBKEngineering/url-builder";

export default BaseFieldView.extend({
  template: _.template(
    '<a href="<%-url%>" data-value="<%-value%>"><%-text%></a>'
  ),

  serialize: function (options) {
    var linkText = options.linkDefaultText;
    var linkUrl = options.linkUrl;
    var urlBuilder = options.urlBuilder || new UrlBuilder("");

    if (options.linkField) {
      linkText = Field.getValue(options.model, options.linkField) || linkText;
    }

    if (_.isFunction(options.linkUrl)) {
      linkUrl = options.linkUrl(options.model);
    }

    return {
      url: urlBuilder.child(String(linkUrl)).url(String(options.value), true),
      value: options.value,
      text: linkText,
    };
  },

  getControlValue: function () {
    return this.$("a").data("value");
  },

  setControlValue: function () {
    this.render();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/LinkView.js
// module id = 851
// module chunks = 1